import React, { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import AddIcon from "@material-ui/icons/Add";
import Fab from "@material-ui/core/Fab";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useTranslation } from "react-multi-lang";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { policyholdersService } from "../../../utils/feathers";
import Table from "../../Table";

const useStyles = makeStyles((theme) => ({
  fab: {
    margin: theme.spacing(1),
    right: 10,
    bottom: 10,
    left: "auto",
    position: "fixed",
  },
}));

function Policyholders() {
  const classes = useStyles();
  const history = useHistory();
  const t = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    skip: 0,
    limit: 50,
    sort: { PolicyHolderId: -1 },
    query: {},
  });

  const errorMessage = t("common.error");

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await policyholdersService.find({
          query: {
            $limit: filters.limit,
            $skip: filters.skip,
            $or: filters.query,
            $sort: filters.sort,
          },
        });

        setTotal(data.total);
        setRows(data.data);
      } catch (e) {
        enqueueSnackbar(errorMessage, { variant: "error" });
      }

      setIsLoading(false);
    }

    fetchData();
  }, [filters, errorMessage, enqueueSnackbar]);

  const changeFilters = ({ skip, query, sort }) => {
    setFilters((prev) => ({ ...prev, skip, query, sort }));
  };

  const onDelete = async (id) => {
    await policyholdersService.remove(id);
  };

  const title = t("policyholders.title");

  return (
    <div>
      <Helmet>
        <title>Attis - {title}</title>
      </Helmet>
      <Table
        title={title}
        path="policyholders"
        idColumn="PolicyHolderId"
        tableColumns={[
          { title: t("policyholders.id"), name: "PolicyHolderId" },
          { title: t("policyholders.email"), name: "Email" },
          { title: t("policyholders.name"), name: "Name" },
          { title: t("policyholders.surname"), name: "Surname" },
          {
            title: t("policyholders.address"),
            name: "Address",
          },
          {
            title: t("policyholders.nif"),
            name: "NIF",
          },
        ]}
        customActions={[
          {
            icon: <VisibilityIcon />,
            action: null,
            path:
              '/policies?filter={"PolicyHolderId":{"$eq":[[PolicyHolderId]]}}',
          },
        ]}
        tableRows={rows}
        totalRows={total}
        changeFilters={changeFilters}
        onDelete={onDelete}
        isLoading={isLoading}
      />
      <Fab
        color="primary"
        aria-label={t("common.new")}
        onClick={() => {
          history.push("/policyholders/new");
        }}
        className={classes.fab}
      >
        <AddIcon />
      </Fab>
    </div>
  );
}

export default Policyholders;
